<template>
  <page
    :custom-style="{
      backgroundColor: isEmpty ? '#fff' : '#332011',
      minHeight: '100vh'
    }"
  >
    <maple-nav-bar
      v-if="!isMiniProgram && !isLoading"
      class="cms-nav-bar"
      left-arrow
      :safe-top-distance="statusBarHeight"
      :opacity-style="!isEmpty"
      :opacity="opacity"
      :title="pageTitle"
      :left-arrow-color="isEmpty ? '#444' : '#fff'"
      :background="background"
      :title-color="titleColor"
      @click-left="goBack"
    />

    <empty
      v-if="isEmpty && !isLoading"
      :desc="'暂无商品'"
      :type="1"
      :img="'Empty'"
      class="empty-box"
    ></empty>

    <template v-else>
      <div
        v-if="!isEmpty"
        ref="expandHeader"
        class="hot-sale-header"
        :style="{
          backgroundImage: 'url(' + headImg + ')'
        }"
      >
        <p class="header-content" :style="{ top: 44 + statusBarHeight + 'px' }">
          {{ pageTitle }}
        </p>
      </div>
      <div v-if="!isEmpty" class="rank-cotent">
        <div
          :class="{
            'expand-tab': true,
            fixed: pageFixed
          }"
          :style="{ top: isMiniProgram ? '0' : 44 + statusBarHeight + 'px' }"
        >
          <div ref="goodRankScrollTabRef" class="anchors">
            <div
              v-for="(item, index) in demandWords"
              id="demand-word-li"
              :ref="`tab-${index}`"
              :key="index"
              :class="[
                'demand-word',
                'demand-word-li',
                { active: index === rankIndex }
              ]"
              @click="changeTab(index)"
            >
              {{ item }}
            </div>
          </div>
        </div>

        <div
          v-for="(item, index) in dataList"
          :id="'goodRankGoodContent' + index"
          :key="index"
          :data-rank-index="index"
          class="demand-good-item"
        >
          <div class="top-info" @click="goDemandWord(item.demandWords)">
            <div class="word">{{ item.demandWords }}</div>
            <div class="more">
              查看更多
              <img
                src="@/images/goods_rank/icon_right.png"
                class="right-icon"
              />
            </div>
          </div>
          <template v-for="(good, skuIndex) in item.demandGoods">
            <component
              :is="getComponentType(good)"
              :key="good.skuBase.skuId"
              :sku-index="skuIndex"
              :sku="good"
              :router-name="'goodsRank'"
              :report-modle="'goodRank'"
              :map-id="'goodRankExpose'"
              :common-tracer-param="{
                datatype: type,
                word_name: item.demandWords,
                pos: index
              }"
            ></component>
          </template>
        </div>
      </div>
    </template>
    <cart-float-window @beforeGoCart="onClickFloatCartTrack" />
  </page>
</template>
<script>
import { miniProgramEnv } from '@/defines/environment'
import { API } from '@/api'
import SkuSingle from '@/common/widgets/newGood/skuSingle'
import SkuMultiple from '@/common/widgets/newGood/skuMultiple'
import Empty from '@/common/layout/empty/index'
import CartFloatWindow from '@/common/widgets/cart_float_window'
import headBgImg from '@/images/goods_rank/rank_head.png'
import { scrollTo, clearScrollTo } from '@/utils/scroll'
import Url from '@mc/mc-utils/js/url/url'
import tracerVuePlugin from '@mc/tracer-vue-plugin'
import { h5Redirect } from '@/utils/native_interactions/h5_wrap/redirect'
import { nativeRoutes } from '@/utils/native_interactions/native_redirect/routes'
export default {
  name: 'GoodsRank',
  components: {
    Empty,
    SkuSingle,
    SkuMultiple,
    CartFloatWindow
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.goodsRank()
    })
  },
  data() {
    return {
      type: 1,
      dataList: [],
      isLoading: true,
      isMiniProgram: miniProgramEnv.isMiniProgram,
      headImg: headBgImg,
      pageTitle: '',
      demandWords: [],
      demandWordIndex: 0,
      opacity: 1,
      background: 'transparent',
      titleColor: 'transparent',
      pageFixed: false,
      scrollTimer: null, // 滚动定时器（点击tab时触发）
      rankIndex: 0
    }
  },
  computed: {
    isEmpty() {
      return this.dataList.length === 0
    }
  },
  // 监控路由状态的改变获取参数重载页面
  watch: {
    rankIndex(v) {
      if (this.$refs.goodRankScrollTabRef) {
        const index = this.rankIndex
        if (index !== -1) {
          const left = this.lefts[index] - 8
          if (this.scrollToId) {
            clearScrollTo(this.scrollToId)
          }
          this.scrollToId = scrollTo(
            this.$refs.goodRankScrollTabRef,
            left,
            'scrollLeft'
          )
        }
      }
    }
  },

  destroyed() {
    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }
  },

  methods: {
    initObserver() {
      if (this.isEmpty) return
      this.$nextTick(() => {
        const tabs = [...this.$el.querySelectorAll('.demand-word-li')]
        this.lefts = tabs.map(tab => tab.offsetLeft)

        this.observer = new IntersectionObserver(
          entries => {
            entries.forEach(entry => {
              const { isIntersecting, target } = entry
              const { rankIndex } = target.dataset
              if (this.isScrollByClick) return
              if (isIntersecting) {
                this.rankIndex = Number(rankIndex)
              }
            })
          },
          {
            rootMargin: '0px 0px 0px 0px',
            threshold: [1]
          }
        )
        this.dataList.forEach((section, index) => {
          const id = 'goodRankGoodContent' + index
          const element = document.getElementById(id)

          if (element) {
            this.observer.observe(element)
          }
        })
      })
    },
    changeTab(index) {
      const name = this.demandWords[index]
      this.$track(this.$trackMap.goodRank.clickTab, {
        word_name: name,
        datatype: this.type,
        pos: index
      })
      if (this.demandWordIndex === index) return
      this.demandWordIndex = index

      this.scrollTo(index)
    },
    scrollTo(index) {
      const id = 'goodRankGoodContent' + index
      const module = document.getElementById(id)
      const navBar = document.querySelector('.cms-nav-bar')
      const navBarHeight = navBar?.getBoundingClientRect?.()?.height || 0
      if (module) {
        const { top } = module.getBoundingClientRect()
        const offset =
          module.compareDocumentPosition(this.$el) &
          Node.DOCUMENT_POSITION_FOLLOWING
            ? 0 // +12
            : 44 // + 12
        this.rankIndex = index

        try {
          window.scrollTo({
            top: top + window.pageYOffset - offset - navBarHeight,
            behavior: 'smooth'
          })
        } catch (err) {
          if (err instanceof TypeError) {
            window.scrollTo(0, top + window.pageYOffset - offset - navBarHeight)
          } else {
            throw err
          }
        }

        this.isScrollByClick = true
        this.scrollTimer = setTimeout(() => {
          clearTimeout(this.scrollTimer)
          this.isScrollByClick = false
        }, Math.abs(top / 600).toFixed(2) * 500)
      }
    },
    getComponentType(good) {
      if (good.ssuList.length === 1) {
        return 'sku-single'
      } else {
        return 'sku-multiple'
      }
    },
    async goodsRank() {
      this.$Loading()
      const url = new Url(window.location.href)
      const query = url.parseQuerystring()
      const hashQuery = url.Hash ? url.Hash.parseQuerystring() : {}
      const type = query.type || hashQuery.type || ''
      this.type = type
      tracerVuePlugin.page('#/goods-rank', {
        datatype: type
      })

      try {
        this.isLoading = true
        this.opacity = 1
        this.background = 'transparent'
        this.titleColor = 'transparent'
        const data = await API.recommend.goodsRank({ type })
        this.dataList = data.rows || []
        this.demandWords = this.dataList.map(item => item.demandWords)
        this.demandWordIndex = 0

        this.pageTitle = data.title || ''
        document.title = this.pageTitle
        this.$nextTick(() => {
          this.handleScroll()
          this.initObserver()
        })
        this.isLoading = false
      } catch (e) {
        console.log('e', e)
        this.isLoading = false
      }
      this.$Loading.hide()
    },

    goBack() {
      this.$back()
    },
    handleScroll() {
      if (this.isEmpty || !this.$refs.expandHeader) return
      window.addEventListener('scroll', e => {
        const boundingTop = this.$refs.expandHeader?.getBoundingClientRect()
          ?.top

        if (boundingTop < -60) {
          this.opacity = 1
          this.background = '#332011'
          this.titleColor = '#fff'
        } else {
          this.background = 'transparent'
          this.titleColor = 'transparent'
        }
        if (boundingTop < -120) {
          this.pageFixed = true
        } else {
          this.pageFixed = false
        }
      })
    },
    goDemandWord(word) {
      this.$track(this.$trackMap.goodRank.seeMore, {
        word_name: word,
        datatype: this.type
      })
      const url = `${nativeRoutes.demandWordRank.h5}?type=${this.type}&word=${word}`
      h5Redirect(url, { transformMAppUrl: false })
    },
    onClickFloatCartTrack() {
      this.$track(this.$trackMap.goodRank.clickFloatCart, {
        datatype: this.type
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.anchors {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  overflow: auto;
  padding-left: 8px;
  padding-top: 8px;
  padding-bottom: 15px;
  background-image: url('../../images/goods_rank/rank_tab.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  box-sizing: border-box;
  // 隐藏滚动条
  &::-webkit-scrollbar {
    display: none;

    background-color: transparent;
  }
}
.hot-sale-header {
  position: relative;

  height: 3.44rem /* 172/50 */;

  color: #fff;
  background-size: 100% 100%;

  .header-content {
    position: absolute;
    top: 1.2rem;

    left: 0.46rem /* 23/50 */;

    @include flex-row-center;

    @include text(0.56rem /* 28/50 */, #ffe1bd, true);
  }
}
.rank-cotent {
  // margin-top: -12px;
  position: relative;
  top: -12px;
  box-sizing: border-box;
  // background-image: url('../../images/goods_rank/rank_tab.png');
  // background-size: 100% 120px;
  // background-repeat: no-repeat;
  // box-sizing: border-box;

  .demand-good-item {
    border-radius: 12px;
    overflow: hidden;
    background-color: #fff;
    margin-bottom: 8px;
    padding-bottom: 6px;
    &:last-child {
      margin-bottom: 0;
    }
    .top-info {
      height: 44px;
      padding: 0 12px;
      background-color: #ff9d001f;
      @include flex-row-between;
      .word {
        @include text(16px, #673900, true);
      }
      .more {
        @include flex-row-center;
        @include text(14px, #673900);
      }
      .right-icon {
        width: 8px;
        height: 8px;
        margin-left: 2px;
      }
    }
  }
}
.expand-tab {
  position: sticky;
  left: 0;
  z-index: 9;
  background-color: transparent;
  &.fixed {
    background-color: #332011;
  }
  .feed-tab-scroll {
    writing-mode: initial !important;
    @include flex(row, flex-start, flex-start, nowrap);
    padding-left: 8px;
    padding-top: 8px;
    padding-bottom: 15px;
  }

  .demand-word {
    width: max-content;
    height: 25px;
    box-sizing: border-box;
    flex: none;
    flex-shrink: 0;
    border-radius: 14px; /* 圆角大小 */
    margin-right: 12px;
    transition: all 0.3s;
    padding: 4px 12px;
    background: #ffffff1a;
    border-radius: 14px;
    @include text(12px, #ffe6c7);
    @include flex-row-center;
    &.active {
      background-image: linear-gradient(90deg, #ffefdb 0%, #ffe1bd 100%);
      color: #673900;
    }
    // &:first-child {
    //   margin-left: 8px;
    // }
  }
}

.cms-nav-bar {
  position: fixed;
  top: 0;
  z-index: $z-navigation-bar;

  width: 100vw;
}
</style>
